import classNames from 'classnames';
import { FC } from 'react';
import Checkbox from '../../../../../../ReactSharedScripts/components/Checkbox';
import { CheckboxProps } from '../../../../../../ReactSharedScripts/components/Checkbox/types';
import classes from './styles/index.module.scss';

type SpreadsheetHeadRowItemCheckboxProps = Pick<CheckboxProps, 'checked' | 'partial' | 'onChange' | 'disabled'> & {
	className?: string;
};

export const SpreadsheetHeadRowCheckboxLayout: FC<SpreadsheetHeadRowItemCheckboxProps> = ({
	className,
	checked,
	partial,
	onChange,
	disabled,
}) => {
	const componentClasses = classNames(classes.headRowItemCheckbox, className);

	return (
		<div className={componentClasses}>
			<Checkbox
				checked={checked}
				partial={partial}
				onChange={onChange}
				disabled={disabled}
			/>
		</div>
	);
};
